"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BetValidator = (function () {
    function BetValidator() {
    }
    BetValidator.error = function (error) {
        this.element.classList.remove('fade');
        this.element.style.display = 'flex';
        document.getElementById('modalErrorMessage').innerHTML = error;
    };
    BetValidator.element = document.getElementById('buyTicketError');
    return BetValidator;
}());
exports.default = BetValidator;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/validators/bet-validator.ts
// module id = 173
// module chunks = 4